import React from "react";

export default function About() {
  return (
    <div className="text-white max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold mb-3">About Urban Unity Network</h1>
      <p className="text-gray-300 mb-6">
        Urban Unity Network (UUN) is a community-led platform that helps residents, local groups, and services
        connect in one place — making it easier to find support, events, and opportunities nearby.
      </p>

      <div className="grid gap-6 md:grid-cols-2">
        <section className="bg-black/40 border border-white/10 rounded-2xl p-6">
          <h2 className="text-xl font-semibold mb-2">What you can do here</h2>
          <ul className="list-disc pl-5 text-sm text-gray-300 space-y-2">
            <li>Search the map for services and activities.</li>
            <li>Browse upcoming community events.</li>
            <li>Explore the local services directory.</li>
            <li>Submit events, services, and locations so others can find them.</li>
          </ul>
        </section>

        <section className="bg-black/40 border border-white/10 rounded-2xl p-6">
          <h2 className="text-xl font-semibold mb-2">How moderation works</h2>
          <p className="text-sm text-gray-300">
            To keep information accurate and community-focused, submissions are reviewed before going live.
            When you submit something, it appears in the admin panel as <span className="font-semibold">Pending</span>.
            Once approved, it becomes visible to everyone.
          </p>
        </section>
      </div>

      <section className="mt-6 bg-black/40 border border-white/10 rounded-2xl p-6">
        <h2 className="text-xl font-semibold mb-2">Privacy (simple & friendly)</h2>
        <ul className="list-disc pl-5 text-sm text-gray-300 space-y-2">
          <li>Browsing is public and doesn’t require an account.</li>
          <li>Saved items in the Profile page are stored locally on your device (no sign-up needed).</li>
          <li>In future, we can add optional resident accounts for cross-device sync.</li>
        </ul>
      </section>
    </div>
  );
}
